import Vue from 'vue';
import Router from 'vue-router';

import AdminFrame from '@/views/layout/AdminFrame';

import store from '../store'

import tijianCompany from './modules/tijian_company';
import company from './modules/company';

Vue.use(Router);
const router = new Router({
  routes: [
       //当前我使用的地址
    {
      path: '/datavisual/index',
      component: () => import('@/views/datavisual/index')
    },
    {
      path: '/datavisual',
      component: () => import('@/views/datavisual/nav'),
      children: [
        {
          path: 'JkzList',
          component: () => import('@/views/datavisual/JkzList'),
          meta: {index: 'i1'},
        },
        {
          path: 'JkzDetail',
          component: () => import('@/views/datavisual/JkzDetail'),
          meta: {index: 'i1'},
        },
        {
          path: 'JkzYichangList',
          component: () => import('@/views/datavisual/JkzYichangList'),
          meta: {index: 'i2'},
        },
        {
          path: 'JkzYichangDetail',
          component: () => import('@/views/datavisual/JkzYichangDetail'),
          meta: {index: 'i2'},
        },
        {
          path: 'out_timing_jkz_list',
          component: () => import('@/views/datavisual/OutTimingJkzList'),
          meta: {index: 'i9'},
        },
        {
          path: 'ExamCenterList',
          component: () => import('@/views/datavisual/ExamCenterList'),
          meta: {index: 'i3'},
        },
        {
          path: 'ExamCenterDetail',
          component: () => import('@/views/datavisual/ExamCenterDetail'),
          meta: {index: 'i3'},
        },
        {
          path: 'MsgList',
          component: () => import('@/views/datavisual/MsgList'),
          meta: {index: 'i4'},
        },

        {
          path: 'MsgDetail',
          component: () => import('@/views/datavisual/MsgDetail'),
          meta: {index: 'i4'},
        },
        {
          path: 'CreateTijian',
          component: () => import('@/views/datavisual/CreateTijian'),
          meta: {index: 'i5'},
        },
        {
          path: 'org_user_count_statist',
          component: () => import('@/views/datavisual/OrgUserCountStatist'),
          meta: {index: 'i5'},
        },
        {
          path: 'company_user_count_statist',
          component: () => import('@/views/datavisual/CompanyUserCountStatist'),
          meta: {index: 'i6'},
        },
        {
          path: 'company_year_tijian_statist',
          component: () => import('@/views/datavisual/CompanyYearTijianStatist'),
          meta: {index: 'i7'},
        },
        {
          path: 'org_year_tijian_statist',
          component: () => import('@/views/datavisual/OrgYearTijianStatist'),
          meta: {index: 'i8'},
        },
        {
          path: 'jkz_list4exam_center_and_month',
          component: () => import('@/views/datavisual/JkzList4ExamCenterAndMonth'),
          meta: {index: 'i8'},
        },
        {
          path: 'change_pwd',
          component: () => import('@/views/datavisual/ChangePwd'),
          meta: {index: 'i23'},
        },
      ]
    },

    //修改重定向地址
    {
      path: '/',
      redirect: '/datavisual/index'
    },

    //当前使用的登录跳转页面
    {
      path: '/login',
      component: () => import('@/views/Login')
    },
    {
      path: '/admin',
      component: AdminFrame,
      children: [
        {
          path: 'index',
          meta: {pageTitle: '管理平台首页', leftMenuIndex: 'admin_index'},
          component: () => import('@/views/admin/Index')
        },
        {
          path: 'system/user-manage',
          meta: {pageTitle: '人员管理', leftMenuIndex: 'admin_system_user-manage'},
          component: () => import('@/views/admin/system/UserManage')
        },

        {
          path: 'system/industry-list',
          meta: {pageTitle: '行业管理', leftMenuIndex: 'admin_system_industry-list'},
          component: () => import('@/views/admin/system/IndustryList')
        },
        {
          path: 'system/tijian-project-type-list',
          meta: {pageTitle: '体检项目分类', leftMenuIndex: 'admin_system_tijian-project-type-list'},
          component: () => import('@/views/admin/system/TijianProjectTypeList')
        },

        {
          path: 'system/common-tijian-project-list',
          meta: {pageTitle: '通用体检项管理', leftMenuIndex: 'admin_system_common-tijian-project-list'},
          component: () => import('@/views/admin/system/CommonTijianProjectList')
        },
        {
          path: 'system/system-param',
          meta: {pageTitle: '系统参数', leftMenuIndex: 'admin_system_system-param'},
          component: () => import('@/views/admin/system/SystemParam')
        },
        {
          path: 'system/hotkey-info',
          meta: {pageTitle: '热键说明', leftMenuIndex: 'admin_system_hotkey-info'},
          component: () => import('@/views/admin/system/HotkeyInfo')
        },
        {
          path: 'tijian/list',
          meta: {pageTitle: '体检记录', leftMenuIndex: 'admin_tijian_list'},
          component: () => import('@/views/admin/tijian/List')
        },
        {
          path: 'tijian/form',
          meta: {pageTitle: '体检信息登记', leftMenuIndex: 'admin_tijian_list'},
          component: () => import('@/views/admin/tijian/Form')
        },
        {
          path: 'system/wx-user-list',
          meta: {pageTitle: '微信用户列表', leftMenuIndex: 'admin_system_wx-user-list'},
          component: () => import('@/views/admin/system/WxUserList')
        },
        {
          path: 'system/case-list',
          meta: {pageTitle: '病历查询', leftMenuIndex: 'admin_system_case-list'},
          component: () => import('@/views/admin/system/CaseList')
        },

        ...tijianCompany,
        ...company,
      ]
    }

  ]
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login' || to.path === '/new_index') {
    next();
  } else {
    let token = store.state.tokenInfo;
    if (token === null || token === '' || token == undefined) {
      next('/login');
    } else {
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js